exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ljr-purpose-selector{border-radius:7px;margin-bottom:6px;display:flex;justify-content:space-between}.ljr-purpose-selector .purpose-selector-button{width:49%;border-radius:13px;background-color:#fff;color:#363636;border:0;height:39px;font-size:14px;text-transform:uppercase}.ljr-purpose-selector .purpose-selector-button:active{background-color:#fff;color:#363636}.ljr-purpose-selector .purpose-selector-button.active,.ljr-purpose-selector .purpose-selector-button.active:active{background-color:#0060c6;color:#fff}.ljr-purpose-selector.add-border{border:1px solid #dedede}@media (max-width:768px){.ljr-purpose-selector{position:relative;top:75px;z-index:10000}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/features/commons/SearchBar/components/PurposeSelector/PurposeSelector.scss
// module id = 686
// module chunks = 0